import React, { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router';
import { BackBar, Loading } from '@/components';
import { Body2Light, Body2, Flex, Container } from '@/ui';
import { investorApi } from '@/api';
import { Title } from '@/ui/typography';
import { userActions } from '@/store/user';
import { useDispatch, useSelector } from 'react-redux';
import { UserOutlined } from '@ant-design/icons';
import { COLORS } from '@/utils/static';

export const ReferralProfileView = () => {
  const dispatch = useDispatch();
  const { id: paramId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(undefined);
  const [referralName, setReferralName] = useState('');
  const { referralToken } = useSelector((state) => state.user);

  useEffect(() => {
    if (paramId) {
      (async () => {
        try {
          const res = await investorApi.getReferralToken(paramId);

          if (res) {
            dispatch(userActions.setReferralToken(res.data.accessToken));
            setReferralName(`${res.data.investor.firstName} ${res.data.investor.lastName}`);
            setLoading(false);
            if (error) setError(undefined);
          }
        } catch (e) {
          setError(e.response.data.message);
          setLoading(false);
        }
      })();
    }
  }, [paramId]);

  return (
    <Flex style={{ backgroundColor: COLORS.white }}>
      <Container $wide $paddingTop={24} $paddingX={60} style={{ flexGrow: 1 }}>
        <Flex justify={'space-between'} align={'center'}>
          <BackBar url='/profile/referrals' />

          {referralName && (
            <Flex gap={16} style={{ flexShrink: 0 }}>
              <Body2>Referral info</Body2>
              <Body2Light>
                <UserOutlined /> {referralName}
              </Body2Light>
            </Flex>
          )}
        </Flex>

        {loading ? (
          <Loading />
        ) : (
          <>
            {error && !referralToken ? (
              <Title level={4} $marginTop={30}>
                {error === 'USER_NOT_FOUND' ? 'User not found.' : error}
              </Title>
            ) : (
              <Outlet />
            )}
          </>
        )}
      </Container>
    </Flex>
  );
};
